<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page_v"></a>Also by Jim Harrison</p>
<p class="centera"><span class="small">FICTION</span></p>
<p class="center"><em>Wolf<br/>A Good Day to Die</em></p>
<p class="center"><em>Farmer<br/>Legends of the Fall<br/>Warlock<br/>Sundog<br/>Dalva</em></p>
<p class="center"><em>The Woman Lit by Fireflies<br/>Julip<br/>The Road Home<br/>The Beast God Forgot to Invent<br/>True North<br/>The Summer He Didn’t Die</em></p>
<p class="centera"><span class="small">CHILDREN’S LITERATURE</span><br/><em>The Boy Who Ran to the Woods</em></p>
<p class="centera"><span class="small">POETRY</span><br/><em>Plain Song<br/>Locations<br/>Outlyer and Ghazals<br/>Letters to Yesenin and Returning to Earth<br/>Selected &amp; New Poems<br/>The Theory and Practice of Rivers &amp; Other Poems</em></p>
<p class="center"><em>After Ikky<span class="en363">ū</span> &amp; Other Poems<br/>The Shape of the Journey: New and Collected Poems<br/>Braided Creek</em> (with Ted Kooser)<br/><em>Saving Daylight</em></p>
<p class="centera"><span class="small">ESSAYS</span><br/><em>Just Before Dark<br/>The Raw and the Cooked</em></p>
<p class="centera"><span class="small">MEMOIR</span><br/><em>Off to the Side</em></p>
<p class="indent"><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface.vue?33bc20e2